import { render, staticRenderFns } from "./ImportSaldoStockistCenter.vue?vue&type=template&id=70565cb7&"
import script from "./ImportSaldoStockistCenter.vue?vue&type=script&lang=js&"
export * from "./ImportSaldoStockistCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports